(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-spinning-wheel"] && !Shopify.designMode) return;
  try {
    
  class KsSpinningWheel extends HTMLElement {
    constructor() {
      super();

      this.dialog = this.closest('dialog');
      this.wheel = null;
      this.initWheel();
      this.handleDialogOpen();
      this.handleDialogClose();
      this.handleFormSubmit();
      this.handleDiscountCodesClick();
    }

    initWheel() {
      const vendorScript = document.querySelector('script[src*="spin-wheel"]');
      const settings = JSON.parse(this.querySelector('script[data-blocks]').textContent).settings;
      const blocks = JSON.parse(this.querySelector('script[data-blocks]').textContent).blocks;

      vendorScript.onload = async () => {
        if (Shopify.designMode) {
          await new Promise((resolve) => setTimeout(resolve, 2000));
        }

        this.wheel = new spinWheel.Wheel(this.querySelector('.ks-snipping-wheel-container'), {
          borderColor: settings.border_color,
          borderWidth: settings.border_width,
          isInteractive: false,
          lineWidth: settings.line_width,
          lineColor: settings.line_color,
          itemLabelFontSizeMax: 16,
          itemLabelRadius: 0.875,
          itemLabelRadiusMax: -0.25,
          radius: 1,
          rotationResistance: 0,
          items: blocks.map((block) => ({
            label: block.label,
            backgroundColor: block.bg_color,
            labelColor: block.label_color,
          })),
          onRest: (event) => {
            console.log(event);
            this.handleWinningBlock(event.currentIndex);
          },
          onSpin: (event) => {
            console.log(event);
          },
        });

        if (this.dataset.wheelSpintAtStart === 'true') {
          this.wheel.spin(5);
        }
      };
    }

    async handleDialogOpen() {
      if (Shopify.designMode) return;

      if (window.location.href.includes('ks-spinning-wheel')) {
        this.dialog.showModal();
      }

      if (this.getCookie('ks-spinning-wheel')) {
        return;
      }

      await new Promise((resolve) => setTimeout(resolve, Number(this.dialog.dataset.configDelay) * 1000));
      this.createCookie('ks-spinning-wheel', true, Number(this.dialog.dataset.configDaysToWait));

      this.dialog.showModal();
    }

    handleDialogClose() {
      this.dialog.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(this.dialog.querySelector('.ks-dialog-inner'));
        if (!withinBoundaries) {
          this.dialog.close();
        }
      });

      this.dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
        event.preventDefault();
        this.dialog.close();
      });
    }

    createCookie(name, value, days) {
      let date, expires;
      if (days) {
        date = new Date();
        date.setDate(date.getDate() + days);
        expires = '; expires=' + date.toUTCString();
      } else {
        expires = '';
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    }

    getCookie(name) {
      let cookies = document.cookie.split('; ');
      for (let cookie of cookies) {
        let [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
          return decodeURIComponent(cookieValue);
        }
      }
      return null;
    }

    handleFormSubmit() {
      const form = this.querySelector('form');
      const button = form.querySelector('button');
      const alertWarning = this.querySelector('.ks-alert-warning');
      const alertSuccess = this.querySelector('.ks-alert-success');

      window.Shopify.captcha.protect(form, () => {
        window.hcaptcha.execute();
      });

      button.addEventListener('click', async (event) => {
        event.preventDefault();

        alertWarning.setAttribute('hidden', 'hidden');
        button.classList.add('loading');
        button.setAttribute('disabled', 'disabled');
        button.querySelector('.loading__spinner').classList.remove('hidden');

        const isTesting = window.location.href.includes('ks-');

        if (isTesting) {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          this.spinWheel();
        } else {
          const formData = new FormData(form);

          const response = await fetch('/contact', {
            method: 'POST',
            body: formData,
          });

          if (response.ok) {
            this.spinWheel();
          } else {
            alertWarning.removeAttribute('hidden');
          }
        }

        button.classList.remove('loading');
        button.removeAttribute('disabled');
        button.querySelector('.loading__spinner').classList.add('hidden');
        this.querySelector('.ks-dialog-form-wrapper').style.opacity = '.2';
      });
    }

    spinWheel() {
      if (this.querySelector('audio')) {
        this.querySelector('audio').play();
      }
      const randomIndex = Math.floor(Math.random() * this.wheel.items.length);
      this.wheel.spinToItem(randomIndex, 4000, false, 4, 1, null);
    }

    handleDiscountCodesClick() {
      this.querySelectorAll('button[data-ks-discount-code]').forEach((button) => {
        button.addEventListener('click', (event) => {
          const discountCode = button.textContent;
          navigator.clipboard.writeText(discountCode);
          button.textContent = button.dataset.textCopied;

          setTimeout(() => {
            button.textContent = discountCode;
          }, 2000);
        });
      });
    }

    handleWinningBlock(index) {
      this.querySelector('.ks-dialog-form-wrapper').setAttribute('hidden', 'hidden');
      this.querySelectorAll('.ks-dialog-winning-block-item').forEach((block, i) => {
        if (i === index) {
          block.removeAttribute('hidden');

          if (block.dataset.confetti === 'true') {
            const jsConfetti = new JSConfetti({
              canvas: this.querySelector('canvas[data-ks-confetti]'),
            });
            jsConfetti.addConfetti();
          }
        }
      });
      if (this.querySelector('audio')) {
        this.querySelector('audio').pause();
      }
    }
  }
  customElements.define('ks-spinning-wheel', KsSpinningWheel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-whatsapp-chat"] && !Shopify.designMode) return;
  try {
     
  class KsWhatsAppChat extends HTMLElement {
    constructor () {
      super ()

      this.chatButton = this.querySelector('#ks-whatsapp-chat-btn')
      this.dialog = this.querySelector('#ks-whatsapp-chat-dialog')
      this.userForm = this.querySelector('#ks-whatsapp-chat-dialog-user-form')
      this.userInput = this.querySelector('#ks-whatsapp-chat-dialog-user-input')
      this.whatsappNumber = this.dataset.whatsappNumber.split('-').join('')
      
      this.handleChatButtonClick()
      this.handelCloseDialogButtonClick()
      this.handleKeyboardIssueMobile()
      this.handleFormSubmit()
    }

    handleChatButtonClick () {
      this.chatButton.addEventListener('click', () => {
        if (this.dataset.hasDialog === 'true') {
          this.openDialog()
        } else {
          this.chatButton.classList.add('loading')
          setTimeout(() => {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
            this.chatButton.classList.remove('loading')
          }, 1000)
        }
      })
    }

    openDialog () {
      if (this.dialog.hasAttribute('open')) {
        this.closeDialog()
        return
      }

      this.dialog.setAttribute('open', '')
      this.setAttribute('data-dialog-open', 'true')

      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-user-input').focus()
      }, 3000)
    
      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-msg-typing').style.display = 'none'
        this.querySelector('#ks-whatsapp-chat-dialog-msg-text').style.display = 'block'
      }, 2000)

      this.trapFocus()
    }

    closeDialog () {
      this.dialog.removeAttribute('open')
      this.setAttribute('data-dialog-open', 'false')
      this.chatButton.focus()
    }
    
    handelCloseDialogButtonClick () {
      this.querySelector('#ks-whatsapp-chat-dialog-close').addEventListener('click', () => {
        this.closeDialog()
      })
    }

    handleKeyboardIssueMobile () {
      this.userInput.addEventListener('focus', () => {
        this.dialog.setAttribute('data-keyboard-open', '')
      })
      this.userInput.addEventListener('blur', () => {
        this.dialog.removeAttribute('data-keyboard-open')
      })
    }

    trapFocus() {
      const focusableElements = this.dialog.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      function handleTab(event) {
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDialog())

      this.dialog.addEventListener('keydown', handleTab)

      return () => {
        this.dialog.removeEventListener('keydown', handleTab)
      }
    }

    handleFormSubmit () {
      this.userForm.addEventListener('submit', (event) => {
        event.preventDefault()
         this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.add('loading')

         setTimeout(() => {
          if (this.userInput.value) {
              const text = encodeURIComponent(this.userInput.value)
              window.open(`https://wa.me/${this.whatsappNumber}?text=${text}`, '_blank')
          } else {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
          }

          this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.remove('loading')
        }, 1000)
      })
    }
  }
  customElements.define('ks-whatsapp-chat', KsWhatsAppChat)

  } catch(e) { console.error(e); }
})();
})();
